import { useCallback } from "react";
import {
  useDisableDistributorSpecialPrice,
  useEnableDistributorSpecialPrice,
} from "../mutations/useStatusDistributorSpecialPriceToggle.mutation";

export const useDistributorSpecialPriceStatusToggle = () => {
  const disableMutation = useDisableDistributorSpecialPrice();
  const enableMutation = useEnableDistributorSpecialPrice(); // Assuming you have a similar mutation for enabling

  const handleEnable = useCallback(
    (id: string) => {
      enableMutation.mutate(id);
    },
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => {
      disableMutation.mutate(id);
    },
    [disableMutation],
  );

  return {
    handleDisable,
    isDisabling: disableMutation.isPending,
    handleEnable,
    isEnabling: enableMutation.isPending,
  };
};
